import React from "react"
import {BikeType, BrandData} from "../utility/Types"

export type DataContextProviderState = {
	bikeFilters: any[],
	horizontalBikesCategoryFilters: any[],
	accessoryFilters: any[],
    data: any,
    setData: (data: any) => void,
    bikes: any[],
	collectionBikes: any[],
	setCollectionBikes: (bikesList: any[] | null) => void,
	accessories:any[],
	height: any,
	categories: any,
	customBikeRecommendations?:BikeType[],
	setHeight: (collections:any[] | null)=> void,
	setCategories: (collections:any[] | null)=> void,
	setAccessories:(accessoriesList:any[] | null)=> void,
	collections:any[],
	setCollections:(collections:any[] | null)=> void,
	brands:any[],
	setBrands:(collections:any[] | null)=> void,
	bikesCountByOption: any[],
	localisedSlugs: any[],
	isCollectionOrBrandPage: boolean,
	pageProps: any,
	maxAmountBlackFridayBikes: number,
	soldAmountBlackFridayBikes: number,
	isBlackFriday: boolean,
	eventListeners: any,
	productHSList: any[],
	setProductHSList: (productHSList: any[] | null) => void,
	setEventListeners: (eventListeners: any) => void,
	comparisonProducts: string[],
	setComparisonProducts:(comparisonProducts: string[]) => void,
	productsCount: number,
	deals: number,
	productsPriceRange: any,
	navigationObjects: any,
	setNavigationObjects: any,
	accessoriesPriceRange: any,
	comparisonAttributes:string[],
	recentlyViewedBikes: any[],
	organizationSlug: string | null,
	organizationInitialized: boolean,
	pageIndex: number,
	brandWorld?: BrandData,
	userLifestyle:string
}

const DataContext = React.createContext<DataContextProviderState>({
	organizationSlug: null,
	organizationInitialized: false,
	userLifestyle: "",
	horizontalBikesCategoryFilters: [],
	productsCount: 0,
	brandWorld: undefined,
	navigationObjects: null,
	setNavigationObjects: () => null,
	comparisonAttributes: [],
	bikeFilters: [],
	accessoryFilters: [],
	data: null,
	setData: () => {
		// Do nothing
	},
	collectionBikes: null,
	customBikeRecommendations: [],
	setCollectionBikes: () => {
		// Do nothing
	},
	bikes: null,
	accessories: null,
	setAccessories: () => {

	},
	collections: null,
	setCollections: () => {

	},
	height: null,
	setHeight: () => {
	},
	categories: null,
	setCategories: () => {
	},
	brands: null,
	setBrands: () => {
	},
	bikesCountByOption: [],
	localisedSlugs: [],
	isCollectionOrBrandPage: false,
	pageProps: null,
	maxAmountBlackFridayBikes: 300,
	soldAmountBlackFridayBikes: 0,
	isBlackFriday: false,
	eventListeners: null,
	setEventListeners: () => {},
	productHSList: [],
	setProductHSList: () => {},
	comparisonProducts: [],
	setComparisonProducts: () => {
	},
	deals: 0,
	productsPriceRange: null,
	accessoriesPriceRange: null,
	recentlyViewedBikes: [],
	pageIndex: 0
})

export default DataContext
